import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import { BiLogOutCircle, BiUserCircle } from "react-icons/bi";
import { IoLogoAndroid } from "react-icons/io";
import { BsApple } from "react-icons/bs";
import {
  List,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
  Avatar,
  Divider,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "../../../app/slices/authSlice";
import { TbSignature } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { TbFileInvoice } from "react-icons/tb";

const ProfileMenu = () => {
  const { user } = useSelector((state) => state.profile);
  const {
    final_accounts: { only_user_ids_can_show },
  } = useSelector((state) => state.statistics);

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const onlyForThisUsers = (id) => {
    return only_user_ids_can_show.includes(id);
  };

  return (
    <div>
      <List role={"button"} onClick={handleMenu}>
        <ListItemButton>
          <ListItemAvatar>
            {user.info.profile_pic ? (
              <Avatar
                src={user.info.profile_pic}
                sx={{
                  border: "1px solid wheat",
                }}
              ></Avatar>
            ) : (
              <Avatar>
                <AccountCircle />
              </Avatar>
            )}
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography variant="h6" fontWeight={"bold"}>
                {user.info?.full_name}
              </Typography>
            }
            secondary={
              <Typography variant="caption" color="wheat">
                {user.info.department?.name} - {user.info.job_title?.name}
              </Typography>
            }
          />
        </ListItemButton>
      </List>

      <Menu
        dir="rtl"
        sx={{ mt: "45px" }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            navigate("/profile");
            handleClose();
          }}
        >
          <ListItemIcon>
            <BiUserCircle size={20} />
          </ListItemIcon>
          <ListItemText primary="الصفحة الشخصية" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open("https://signature.orderii.com/", "_blank");
            handleClose();
          }}
        >
          <ListItemIcon>
            <TbSignature size={20} />
          </ListItemIcon>
          <ListItemText primary="أنشاء توقيع" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(
              "https://hrms-api.orderii.com/storage/downloads/hrms.apk",
              "_blank"
            );
            handleClose();
          }}
        >
          <ListItemIcon>
            <IoLogoAndroid size={20} />
          </ListItemIcon>
          <ListItemText primary="تحميل تطبيق الاندرويد" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open("https://testflight.apple.com/join/Mrcoo96t", "_blank");
            handleClose();
          }}
        >
          <ListItemIcon>
            <BsApple size={20} />
          </ListItemIcon>
          <ListItemText primary="تحميل تطبيق الايفون" />
        </MenuItem>
        {onlyForThisUsers(user.info.id) && (
          <MenuItem
            onClick={() => {
              navigate("/final-accounts");
              handleClose();
            }}
          >
            <ListItemIcon>
              <TbFileInvoice size={20} />
            </ListItemIcon>
            <ListItemText primary="الحسابات الختامية" />
          </MenuItem>
        )}

        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            dispatch(Auth.logout());
          }}
        >
          <ListItemIcon>
            <BiLogOutCircle />
          </ListItemIcon>
          <ListItemText primary="تسجيل خروج" />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
